<h2 mat-dialog-title>{{ 'tasker.common.map' | translate }}</h2>
<div *ngIf="(geolocationGranted$ | async) === false">
  <b style="color: var(--btn-red); margin-left: 15px;">{{ 'tasker.attendance-dialog.position-error.permission-denied' | translate }}</b>
</div>
<mat-dialog-content class="large-dialog">
  <locations-map-component [showOnlyUserRelated]="data.showOnlyUserRelated" 
                           [highlightedLocationIDs]="data.highlightedLocationIDs"
                           [centerToPosition]="data.centerToPosition"
                           #locationsMapComponent
                           fxFlex>
  </locations-map-component>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'tasker.common.close' | translate }}</button>
</mat-dialog-actions>